import { zfUtils } from "./zf_utils";
export class zfcsmf {
    static init() {
        if (zfUtils.isCookieTypeAllowed("Targeting") &&
            $(".zfcsmf-social-widget").length > 0) {
            var s = document.createElement("script");
            s.src = "https://platform.twitter.com/widgets.js";
            document.body.appendChild(s);
            var s2 = document.createElement("script");
            s2.src = "//platform.linkedin.com/in.js";
            document.body.appendChild(s2);
            (function (d, s, id) {
                var js, fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id))
                    return;
                js = d.createElement(s);
                js.id = id;
                js.src =
                    "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.8";
                fjs.parentNode.insertBefore(js, fjs);
            })(document, "script", "facebook-jssdk");
            $(".zfcsmf-social-widget").each(function (index, item) {
                if ($(item).length > 0) {
                    $(item).find(".zfc-accept-cookies").hide();
                    if ($(item).data("social") != undefined)
                        $(item).append($(item).data("social"));
                }
            });
        }
    }
}
zfUtils.onReady(zfcsmf.init);
